module.exports = __webpack_public_path__ + "img/found.dc45c116.png";